import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customTranslate',
    standalone: false
})

export class CustomTranslatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value && value.match(/\d{4}$/)) {
      value = value.substring(0, value.length - 5);
    }
    return value ? value.replaceAll('  ', ' ').replaceAll(' ', '_').replaceAll('-', '_').replaceAll('.', '').toUpperCase() : '';
  }

}
